module.exports = __webpack_public_path__ + "static/media/branding-logo-topbar.628a2a9d.png";